export default {
    // --------Title--------
    taxRates: 'Tax Rates',
    newTaxRate: 'New Tax Rate',
    updateTaxRate: 'Update Tax Rate',
    rateName: 'Rate Name',
    taxPercentage: 'Tax Percentage',
    rateInfo: 'Rate Info',
    detailsOfTaxRateCharges: 'Details of tax rate charges',

};